import Alpine from "alpinejs";
import { normalizeWhitespace } from "../../helpers/stringHelpers";

Alpine.magic("normalizeWhitespace", () => (str) => {
  return normalizeWhitespace(str);
});
